import { render, staticRenderFns } from "./arrow-long-right-fill.svg?vue&type=template&id=5fe78c48"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports